import React from 'react';
import ShopPage from './ShopPage';
import './ShopPage.css';

const ShopPageAccess = () => {
  return <ShopPage collectionName="shopItemsAccess-v2" />;
};

export default ShopPageAccess;
